import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContent';
import { CartProvider } from './contexts/CartContent';
import { StoreProvider } from './contexts/StoreContent';
import { OrderProvider } from './contexts/OrderContent';
import { I18nextProvider } from 'react-i18next';
import { NotificationProvider } from './contexts/NotificationContext';
import { ScrollProvider } from './contexts/ScrollContext';
import { ApolloProvider } from '@apollo/client';
import createApolloClient from './lib/apollo';
// import LoginPage from './pages/';
import LandingPage from './pages/LandingPage';
import BodyContainer from './components/BodyContainer';
import HomePage from './pages/HomePage';
import OutletPage from './pages/OutletPage';
import StorePage from './pages/StorePage';
import ProductPage from './pages/ProductPage';
import CartPage from './pages/CartPage';
import CheckOutPage from './pages/CheckOutPage';
import OrderPage from './pages/OrderPage';
import Loading from './components/LoadingScreen';
import QR from './pages/QR';
import i18n from './services/i18n';
import { LoadingProvider } from './contexts/LoadingContent';
import AccountPage from './pages/AccountPage';
import OrderHistoryPage from './pages/OrderHistoryPage';
import OrderSummaryPage from './pages/OrderSummaryPage';
import ExpireQrPage from './pages/ExpireQrPage';
import InvalideQrPage from './pages/InvalideQrPage';
import Notification from './components/Notification';
import EditAccountPage from './pages/EditAccountPage';
import EditLocationPage from './pages/EditLocationPage';
import AddressManagementPage from './pages/AddressManagementPage';
import OrderHistoryDetailPage from './pages/OrderHistoryDetailPage';
import NotFoundPage from './pages/NotFoundPage';
import { LanguageProvider } from './contexts/LanguageContent';
import PaymentStatusPage from './pages/PaymentStatusPage';
import Spay from './pages/Spay';
import LoginPage from './pages/LoginPage';
import EmailLoginPage from './pages/EmailLoginPage';
import InputPhoneNumberPage from './pages/InputPhoneNumberPage';
import OtpVerificationPage from './pages/OtpVerificationPage';
import ProtectedRoute from './components/ProtectedRoute';
import EmailRegisterPage from './pages/EmailRegisterPage';

function App() {

    const client = createApolloClient();

    return (
        <I18nextProvider i18n={i18n}>
            <ApolloProvider client={client}>
                <Router>
                    <LanguageProvider>
                        <ScrollProvider>
                            <LoadingProvider>
                                <NotificationProvider>
                                    <AuthProvider>
                                        <CartProvider>
                                            <StoreProvider>
                                                <OrderProvider>
                                                    <Loading />
                                                    <Notification />
                                                    <BodyContainer>
                                                        <Routes>
                                                            <Route path="/home" element={<HomePage />} />
                                                            <Route path="/login" element={<ProtectedRoute element={<LoginPage />} restricted={true} />} />
                                                            <Route path="/emailRegister" element={<ProtectedRoute element={<EmailRegisterPage />} restricted={true} />} />
                                                            <Route path="/inputPhoneNumber" element={<ProtectedRoute element={<InputPhoneNumberPage />} restricted={true} />} />
                                                            <Route path="/emailLogin" element={<ProtectedRoute element={<EmailLoginPage />} restricted={true} />} />
                                                            <Route path="/otpVerification" element={<ProtectedRoute element={<OtpVerificationPage />} restricted={true} />} />
                                                            <Route path="/qr/:qrCode" element={<QR />} />
                                                            <Route path="/outlet" element={<OutletPage />} />
                                                            <Route path="/store" element={<StorePage />} />
                                                            <Route path="/editLocation" element={<EditLocationPage />} />
                                                            <Route path="/editAccount" element={<EditAccountPage />} />
                                                            <Route path="/qrExpire" element={<ExpireQrPage />} />
                                                            <Route path="/Spay" element={<Spay />} />
                                                            <Route path="/invalidQr" element={<InvalideQrPage />} />
                                                            <Route path="/orderHistory" element={<OrderHistoryPage />} />
                                                            <Route path="/account" element={<AccountPage />} />
                                                            <Route path="/addressManagement" element={<AddressManagementPage />} />
                                                            <Route path="/product/:storeId" element={<ProductPage />} />
                                                            <Route path="/orderHistoryDetail/:billGroupNo" element={<OrderHistoryDetailPage />} />
                                                            <Route path="/orderDetail/:billGroupNo" element={<OrderSummaryPage />} />
                                                            <Route path="/cart" element={<CartPage />} />
                                                            <Route path="/paymentStatus" element={<PaymentStatusPage />} />
                                                            <Route path="/checkOut" element={<CheckOutPage />} />
                                                            <Route path="/order/:billGroupNo" element={<OrderPage />} />
                                                            <Route path="/" element={<ProtectedRoute element={<LandingPage />} restricted={true} />} />
                                                            <Route path="*" element={<NotFoundPage />} />
                                                        </Routes>
                                                    </BodyContainer>
                                                </OrderProvider>
                                            </StoreProvider>
                                        </CartProvider>
                                    </AuthProvider>
                                </NotificationProvider>
                            </LoadingProvider>
                        </ScrollProvider>
                    </LanguageProvider>
                </Router>
            </ApolloProvider>
        </I18nextProvider>
    );
}

export default App;
